import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login', component: () => import('../pages/login'),
      meta: { 'title': '登录', keepAlive: false },
      name: 'login'
    },
    {
      path: '/', component: () => import('../pages/index'),
      meta: { 'title': '首页', keepAlive: false },
      name: '/'
    },
    {
      path: '/purchaseOrder', component: () => import('../pages/purchaseOrder'),
      meta: { 'title': '采购订单', keepAlive: false },
      name: 'purchaseOrder'
    },
    {
      path: '/purchaseOrderEdit', component: () => import('../pages/purchaseOrderEdit'),
      meta: { 'title': '', keepAlive: false },
      name: 'purchaseOrderEdit'
    },
    {
      path: '/purchaseOrderAudit', component: () => import('../pages/purchaseOrderAudit'),
      meta: { 'title': '采购审核', keepAlive: false },
      name: 'purchaseOrderAudit'
    },
    {
      path: '/purchaseOrderView', component: () => import('../pages/purchaseOrderView'),
      meta: { 'title': '采购查看', keepAlive: false },
      name: 'purchaseOrderView'
    },
    {
      path: '/purchaseReceipt', component: () => import('../pages/purchaseReceipt'),
      meta: { 'title': '采购入库单', keepAlive: false },
      name: 'purchaseReceipt'
    },
    {
      path: '/purchaseReceiptEdit', component: () => import('../pages/purchaseReceiptEdit'),
      meta: { 'title': '', keepAlive: false },
      name: 'purchaseReceiptEdit'
    },
    {
      path: '/purchaseReceiptAudit', component: () => import('../pages/purchaseReceiptAudit'),
      meta: { 'title': '采购入库审核', keepAlive: false },
      name: 'purchaseReceiptAudit'
    },
    {
      path: '/purchaseReceiptView', component: () => import('../pages/purchaseReceiptView'),
      meta: { 'title': '采购入库查看', keepAlive: false },
      name: 'purchaseReceiptView'
    },
    {
      path: '/purchaseReturns', component: () => import('../pages/purchaseReturns'),
      meta: { 'title': '采购退货出库单', keepAlive: false },
      name: 'purchaseReturns'
    },
    {
      path: '/purchaseReturnsEdit', component: () => import('../pages/purchaseReturnsEdit'),
      meta: { 'title': '', keepAlive: false },
      name: 'purchaseReturnsEdit'
    },
    {
      path: '/purchaseReturnsAudit', component: () => import('../pages/purchaseReturnsAudit'),
      meta: { 'title': '采购退货出库审核', keepAlive: false },
      name: 'purchaseReturnsAudit'
    },
    {
      path: '/purchaseReturnsView', component: () => import('../pages/purchaseReturnsView'),
      meta: { 'title': '采购退货出库查看', keepAlive: false },
      name: 'purchaseReturnsView'
    },
    {
      path: '/purchaseReport', component: () => import('../pages/purchaseReport'),
      meta: { 'title': '采购价异动报告', keepAlive: false },
      name: 'purchaseReport'
    },
    {
      path: '/onlineOrder', component: () => import('../pages/onlineOrder'),
      meta: { 'title': '线上订单', keepAlive: false },
      name: 'onlineOrder'
    },
    {
      path: '/onlineOrderView', component: () => import('../pages/onlineOrderView'),
      meta: { 'title': '订单详情', keepAlive: false },
      name: 'onlineOrderView'
    },
    {
      path: '/retailOutboundOrder', component: () => import('../pages/retailOutboundOrder'),
      meta: { 'title': '零售出库单', keepAlive: false },
      name: 'retailOutboundOrder'
    },
    {
      path: '/retailOutboundOrderEdit', component: () => import('../pages/retailOutboundOrderEdit'),
      meta: { 'title': '', keepAlive: false },
      name: 'retailOutboundOrderEdit'
    },
    {
      path: '/retailOutboundOrderA', component: () => import('../pages/retailOutboundOrderA'),
      meta: { 'title': '零售出库单审核', keepAlive: false },
      name: 'retailOutboundOrderA'
    },
    {
      path: '/retailOutboundOrderV', component: () => import('../pages/retailOutboundOrderV'),
      meta: { 'title': '零售出库单查看', keepAlive: false },
      name: 'retailOutboundOrderV'
    },
    {
      path: '/retailReturnForm', component: () => import('../pages/retailReturnForm'),
      meta: { 'title': '零售退货入库单', keepAlive: false },
      name: 'retailReturnForm'
    },
    {
      path: '/retailReturnFormEdit', component: () => import('../pages/retailReturnFormEdit'),
      meta: { 'title': '', keepAlive: false },
      name: 'retailReturnFormEdit'
    },
    {
      path: '/retailReturnFormA', component: () => import('../pages/retailReturnFormA'),
      meta: { 'title': '零售退货入库单审核', keepAlive: false },
      name: 'retailReturnFormA'
    },
    {
      path: '/retailReturnFormV', component: () => import('../pages/retailReturnFormV'),
      meta: { 'title': '零售退货入单查看', keepAlive: false },
      name: 'retailReturnFormV'
    },
    {
      path: '/externalTransferOrder', component: () => import('../pages/externalTransferOrder'),
      meta: { 'title': '外部调拨单', keepAlive: false },
      name: 'externalTransferOrder'
    },
    {
      path: '/externalTransferOrderE', component: () => import('../pages/externalTransferOrderE'),
      meta: { 'title': '', keepAlive: false },
      name: 'externalTransferOrderE'
    },
    {
      path: '/externalTransferOrderA', component: () => import('../pages/externalTransferOrderA'),
      meta: { 'title': '外部调拨审核', keepAlive: false },
      name: 'externalTransferOrderA'
    },
    {
      path: '/externalTransferOrderV', component: () => import('../pages/externalTransferOrderV'),
      meta: { 'title': '外部调拨查看', keepAlive: false },
      name: 'externalTransferOrderV'
    },
    {
      path: '/externalTransferOrderO', component: () => import('../pages/externalTransferOrderO'),
      meta: { 'title': '外部调拨确认', keepAlive: false },
      name: 'externalTransferOrderO'
    },
    {
      path: '/reservationOrder', component: () => import('../pages/reservationOrder'),
      meta: { 'title': '预约订单', keepAlive: false },
      name: 'reservationOrder'
    },
    {
      path: '/unpaidAccount', component: () => import('../pages/unpaidAccount'),
      meta: { 'title': '挂账销账', keepAlive: false },
      name: 'unpaidAccount'
    },
    {
      path: '/couponManagement', component: () => import('../pages/couponManagement'),
      meta: { 'title': '优惠券管理', keepAlive: false },
      name: 'couponManagement'
    },
    {
      path: '/couponCollection', component: () => import('../pages/couponCollection'),
      meta: { 'title': '优惠券领取', keepAlive: false },
      name: 'couponCollection'
    },
    {
      path: '/memberManagement', component: () => import('../pages/memberManagement'),
      meta: { 'title': '会员管理', keepAlive: false },
      name: 'memberManagement'
    },
    {
      path: '/memberManagementItem', component: () => import('../pages/memberManagementItem'),
      meta: { 'title': '会员详情', keepAlive: false },
      name: 'memberManagementItem'
    },
    {
      path: '/evaluationManagement', component: () => import('../pages/evaluationManagement'),
      meta: { 'title': '评价管理', keepAlive: false },
      name: 'evaluationManagement'
    },
    {
      path: '/operatingFunds', component: () => import('../pages/operatingFunds'),
      meta: { 'title': '营业款日结单', keepAlive: false },
      name: 'operatingFunds'
    },
    {
      path: '/operatingFundsE', component: () => import('../pages/operatingFundsE'),
      meta: { 'title': '', keepAlive: false },
      name: 'operatingFundsE'
    },
    {
      path: '/operatingFundsA', component: () => import('../pages/operatingFundsA'),
      meta: { 'title': '营业款日结单审核', keepAlive: false },
      name: 'operatingFundsA'
    },
    {
      path: '/operatingFundsV', component: () => import('../pages/operatingFundsV'),
      meta: { 'title': '营业款日结单查看', keepAlive: false },
      name: 'operatingFundsV'
    },
    {
      path: '/statements', component: () => import('../pages/statements'),
      meta: { 'title': '营业款对账单', keepAlive: false },
      name: 'statements'
    },
    {
      path: '/fundClearingDetails', component: () => import('../pages/fundClearingDetails'),
      meta: { 'title': '资金清缴明细', keepAlive: false },
      name: 'fundClearingDetails'
    },
    {
      path: '/inventoryQuery', component: () => import('../pages/inventoryQuery'),
      meta: { 'title': '库存查询', keepAlive: false },
      name: 'inventoryQuery'
    },
    {
      path: '/inventoryAnalysis', component: () => import('../pages/inventoryAnalysis'),
      meta: { 'title': '库存分析', keepAlive: false },
      name: 'inventoryAnalysis'
    },
    {
      path: '/inventorySurplusOrder', component: () => import('../pages/inventorySurplusOrder'),
      meta: { 'title': '库存盘盈单', keepAlive: false },
      name: 'inventorySurplusOrder'
    },
    {
      path: '/inventorySurplusOrderE', component: () => import('../pages/inventorySurplusOrderE'),
      meta: { 'title': '', keepAlive: false },
      name: 'inventorySurplusOrderE'
    },
    {
      path: '/inventorySurplusOrderA', component: () => import('../pages/inventorySurplusOrderA'),
      meta: { 'title': '盘盈单审核', keepAlive: false },
      name: 'inventorySurplusOrderA'
    },
    {
      path: '/inventorySurplusOrderV', component: () => import('../pages/inventorySurplusOrderV'),
      meta: { 'title': '盘盈单查看', keepAlive: false },
      name: 'inventorySurplusOrderV'
    },
    {
      path: '/inventoryLossOrder', component: () => import('../pages/inventoryLossOrder'),
      meta: { 'title': '库存盘亏单', keepAlive: false },
      name: 'inventoryLossOrder'
    },
    {
      path: '/inventoryLossOrderE', component: () => import('../pages/inventoryLossOrderE'),
      meta: { 'title': '', keepAlive: false },
      name: 'inventoryLossOrderE'
    },
    {
      path: '/inventoryLossOrderA', component: () => import('../pages/inventoryLossOrderA'),
      meta: { 'title': '盘亏单审核', keepAlive: false },
      name: 'inventoryLossOrderA'
    },
    {
      path: '/inventoryLossOrderV', component: () => import('../pages/inventoryLossOrderV'),
      meta: { 'title': '盘亏单查看', keepAlive: false },
      name: 'inventoryLossOrderV'
    },
    {
      path: '/internalTransferOrder', component: () => import('../pages/internalTransferOrder'),
      meta: { 'title': '内部转仓单', keepAlive: false },
      name: 'internalTransferOrder'
    },
    {
      path: '/internalTransferOrderE', component: () => import('../pages/internalTransferOrderE'),
      meta: { 'title': '', keepAlive: false },
      name: 'internalTransferOrderE'
    },
    {
      path: '/internalTransferOrderA', component: () => import('../pages/internalTransferOrderA'),
      meta: { 'title': '内部转仓审核', keepAlive: false },
      name: 'internalTransferOrderA'
    },
    {
      path: '/internalTransferOrderV', component: () => import('../pages/internalTransferOrderV'),
      meta: { 'title': '内部转仓查看', keepAlive: false },
      name: 'internalTransferOrderV'
    },
    {
      path: '/warehouseManagement', component: () => import('../pages/warehouseManagement'),
      meta: { 'title': '仓库管理', keepAlive: false },
      name: 'warehouseManagement'
    },
    {
      path: '/purchase', component: () => import('../pages/purchase'),
      meta: { 'title': '采购报表', keepAlive: false },
      name: 'purchase'
    },
    {
      path: '/retail', component: () => import('../pages/retail'),
      meta: { 'title': '销售-商品和增值服务报表', keepAlive: false },
      name: 'retail'
    },
    {
      path: '/exchange', component: () => import('../pages/exchange'),
      meta: { 'title': '调拨报表', keepAlive: false },
      name: 'exchange'
    },
    {
      path: '/check', component: () => import('../pages/check'),
      meta: { 'title': '盘盈盘亏报表', keepAlive: false },
      name: 'check'
    },
    {
      path: '/pay', component: () => import('../pages/pay'),
      meta: { 'title': '支付方式汇总报表', keepAlive: false },
      name: 'pay'
    },
    {
      path: '/member', component: () => import('../pages/member'),
      meta: { 'title': '会员报表', keepAlive: false },
      name: 'member'
    },
    {
      path: '/stock', component: () => import('../pages/stock'),
      meta: { 'title': '库存报表', keepAlive: false },
      name: 'stock'
    },
    {
      path: '/stock2', component: () => import('../pages/stock2'),
      meta: { 'title': '库存报表2', keepAlive: false },
      name: 'stock2'
    },
    {
      path: '/goods', component: () => import('../pages/goods'),
      meta: { 'title': '商品报表', keepAlive: false },
      name: 'goods'
    },
    {
      path: '/progressStatistics', component: () => import('../pages/progressStatistics'),
      meta: { 'title': '进度统计报表', keepAlive: false },
      name: 'progressStatistics'
    },
    {
      path: '/commodityManagement', component: () => import('../pages/commodityManagement'),
      meta: { 'title': '商品管理', keepAlive: false },
      name: 'commodityManagement'
    },
    {
      path: '/commodityManagementE', component: () => import('../pages/commodityManagementE'),
      meta: { 'title': '', keepAlive: false },
      name: 'commodityManagementE'
    },
    {
      path: '/categories', component: () => import('../pages/categories'),
      meta: { 'title': '商品分类', keepAlive: false },
      name: 'categories'
    },
    {
      path: '/brandManagement', component: () => import('../pages/brandManagement'),
      meta: { 'title': '品牌管理', keepAlive: false },
      name: 'brandManagement'
    },
    {
      path: '/bannerManage', component: () => import('../pages/bannerManage'),
      meta: { 'title': 'banner管理', keepAlive: false },
      name: 'bannerManage'
    },
    {
      path: '/appointmentQuestions', component: () => import('../pages/appointmentQuestions'),
      meta: { 'title': '预约问题', keepAlive: false },
      name: 'appointmentQuestions'
    },
    {
      path: '/appointmentSettings', component: () => import('../pages/appointmentSettings'),
      meta: { 'title': '预约设置', keepAlive: false },
      name: 'appointmentSettings'
    },
    {
      path: '/supplier', component: () => import('../pages/supplier'),
      meta: { 'title': '供货商', keepAlive: false },
      name: 'supplier'
    },
    {
      path: '/membershipSettings', component: () => import('../pages/membershipSettings'),
      meta: { 'title': '会员设置', keepAlive: false },
      name: 'membershipSettings'
    },
    {
      path: '/valueAddedServices', component: () => import('../pages/valueAddedServices'),
      meta: { 'title': '增值服务', keepAlive: false },
      name: 'valueAddedServices'
    },
    {
      path: '/valueAddedServicesClass', component: () => import('../pages/valueAddedServicesClass'),
      meta: { 'title': '增值服务分类', keepAlive: false },
      name: 'valueAddedServicesClass'
    },
    {
      path: '/progressStatisticsClass', component: () => import('../pages/progressStatisticsClass'),
      meta: { 'title': '进度统计分类', keepAlive: false },
      name: 'progressStatisticsClass'
    },
    {
      path: '/accountUnit', component: () => import('../pages/accountUnit'),
      meta: { 'title': '挂账单位', keepAlive: false },
      name: 'accountUnit'
    },
    {
      path: '/storeManagement', component: () => import('../pages/storeManagement'),
      meta: { 'title': '门店管理', keepAlive: false },
      name: 'storeManagement'
    },
    {
      path: '/roleManagement', component: () => import('../pages/roleManagement'),
      meta: { 'title': '角色管理', keepAlive: false },
      name: 'roleManagement'
    },
    {
      path: '/rolePermissionSettings', component: () => import('../pages/rolePermissionSettings'),
      meta: { 'title': '角色权限设置', keepAlive: false },
      name: 'rolePermissionSettings'
    },
    {
      path: '/userManagement', component: () => import('../pages/userManagement'),
      meta: { 'title': '用户管理', keepAlive: false },
      name: 'userManagement'
    },
    {
      path: '/maintenanceServiceSettings', component: () => import('../pages/maintenanceServiceSettings'),
      meta: { 'title': '维修服务设置', keepAlive: false },
      name: 'maintenanceServiceSettings'
    },
    {
      path: '/maintenancePriceSetting', component: () => import('../pages/maintenancePriceSetting'),
      meta: { 'title': '维修价格设置', keepAlive: false },
      name: 'maintenancePriceSetting'
    },
    {
      path: '/otherProductSettings', component: () => import('../pages/otherProductSettings'),
      meta: { 'title': '内容设置', keepAlive: false },
      name: 'otherProductSettings'
    },
    {
      path: '/orderVerification', component: () => import('../pages/orderVerification'),
      meta: { 'title': '待处理订单', keepAlive: false },
      name: 'orderVerification'
    },
    {
      path: '/orderVerificationItem', component: () => import('../pages/orderVerificationItem'),
      meta: { 'title': '待处理订单详情', keepAlive: false },
      name: 'orderVerificationItem'
    },
    {
      path: '/bookingManagement', component: () => import('../pages/bookingManagement'),
      meta: { 'title': '预约到店', keepAlive: false },
      name: 'bookingManagement'
    },
    {
      path: '/bookingManagementItem', component: () => import('../pages/bookingManagementItem'),
      meta: { 'title': '预约到店详情', keepAlive: false },
      name: 'bookingManagementItem'
    },
    {
      path: '/mailingForrepair', component: () => import('../pages/mailingForrepair'),
      meta: { 'title': '邮寄送修', keepAlive: false },
      name: 'mailingForrepair'
    },
    {
      path: '/mailingForrepairItem', component: () => import('../pages/mailingForrepairItem'),
      meta: { 'title': '邮寄送修详情', keepAlive: false },
      name: 'mailingForrepairItem'
    },
    {
      path: '/shareRecords', component: () => import('../pages/shareRecords'),
      meta: { 'title': '分享记录', keepAlive: false },
      name: 'shareRecords'
    },
    {
      path: '/appointmentIssues', component: () => import('../pages/appointmentIssues'),
      meta: { 'title': '预约问题设置', keepAlive: false },
      name: 'appointmentIssues'
    },
    {
      path: '/tradeIn', component: () => import('../pages/tradeIn'),
      meta: { 'title': '以旧换新', keepAlive: false },
      name: 'tradeIn'
    },
    {
      path: '/tradeInItem', component: () => import('../pages/tradeInItem'),
      meta: { 'title': '以旧换新详情', keepAlive: false },
      name: 'tradeInItem'
    },
    {
      path: '/dataDictionary', component: () => import('../pages/dataDictionary'),
      meta: { 'title': '数据字典', keepAlive: false },
      name: 'dataDictionary'
    },
    {
      path: '/systemParameter', component: () => import('../pages/systemParameter'),
      meta: { 'title': '系统参数', keepAlive: false },
      name: 'systemParameter'
    },
    {
      path: '/recyclingStatistics', component: () => import('../pages/recyclingStatistics'),
      meta: { 'title': '回收统计', keepAlive: false },
      name: 'recyclingStatistics'
    },
    {
      path: '/collectionVerification', component: () => import('../pages/collectionVerification'),
      meta: { 'title': '回收款核销', keepAlive: false },
      name: 'collectionVerification'
    },
    {
      path: '/oldMachineRecycling', component: () => import('../pages/oldMachineRecycling'),
      meta: { 'title': '旧机回收', keepAlive: false },
      name: 'oldMachineRecycling'
    },
    {
      path: '/oldMachineRecyclingE', component: () => import('../pages/oldMachineRecyclingE'),
      meta: { 'title': '', keepAlive: false },
      name: 'oldMachineRecyclingE'
    },
    {
      path: '/oldMachineRecyclingT', component: () => import('../pages/oldMachineRecyclingT'),
      meta: { 'title': '', keepAlive: false },
      name: 'oldMachineRecyclingT'
    },
    {
      path: '/oldMachineRecyclingDeT', component: () => import('../pages/oldMachineRecyclingDeT'),
      meta: { 'title': '', keepAlive: false },
      name: 'oldMachineRecyclingDeT'
    },
    {
      path: '/oldMachineRecyclingV', component: () => import('../pages/oldMachineRecyclingV'),
      meta: { 'title': '旧机回收查看', keepAlive: false },
      name: 'oldMachineRecyclingV'
    },
    {
      path: '/openId', component: () => import('../pages/openId'),
      meta: { 'title': '微信ID查询', keepAlive: false },
      name: 'openId'
    },
    {
      path: '/pushSettings', component: () => import('../pages/pushSettings'),
      meta: { 'title': '推送设置', keepAlive: false },
      name: 'pushSettings'
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js